export function safeParse<T>(value: string | null, fallback: T): T {
    try {
        if (!value) {
            return fallback;
        }
        return JSON.parse(value) as T;
    } catch {
        return fallback;
    }
}
